import { getUserTierProgress } from './../../services/api-membership.service';
import { useQuery, UseQueryOptions } from 'react-query';
import { IUserTierProgress } from 'shared/interfaces/membership.interface';

const GET_USER_TIER_PROGRESS = 'get_user_tier_progress';

export const useUserTierProgress = (
  userId: string,
  options?: UseQueryOptions<IUserTierProgress, unknown>
) =>
  useQuery(
    [GET_USER_TIER_PROGRESS, userId],
    () => getUserTierProgress(userId),
    options
  );
